import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import ReactHTML from '../../../components/ReactHTML';

export type DescriptionSectionProps = {
    description: string | null;
};

export const DescriptionSection: FunctionComponent<DescriptionSectionProps> = ({ description }) => {
    if (!description) return null;

    return (
        <article
            className={styles.description_section}
            aria-labelledby="description-header"
            tabIndex={0}
        >
            <h2 id="description-header" className={styles.descriptionHeader}>
                Description
            </h2>
            <ReactHTML html={description} />
        </article>
    );
};

export default DescriptionSection;
